module.exports = __webpack_public_path__ + "img/logolarge.07e1a022.png";